import axios from 'axios';
import Config from '@/config';
import {Form, Field, Button, Toast} from 'vant';
import {getExtName, getUrlRelativePath} from '@/libs/util';
import {getUploadPrivateParams, deleteUploadFile} from '@/api';

export default {
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [Button.name]: Button
    },
    data() {
        return {
            currentDatetimePickerField: null,
            showDatetimePicker: false,
            minDate: new Date(2020, 3, 1),
            maxDate: new Date(2040, 11, 31),
            currentDate: new Date(),
        };
    },
    methods: {
        datetimeFormatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            } else if (type === 'hour') {
                return `${val}时`;
            } else if (type === 'minute') {
                return `${val}分`;
            }
            return val;
        },
        validatorDatetime(datetime) {
            return true;
        },
        uploadBeforeRead(file) {
            file.isImage = true;
            file.deletable = false;
            return ['png', 'jpg', 'jpeg', 'gif'].includes(getExtName(file.name).toLowerCase());
        },
        uploadAfterRead(file) {
            getUploadPrivateParams({prefix: 'station/repair', extName: getExtName(file.file.name)}).then(response => {
                if (response.data.code === Config.successCode) {
                    this.upload(response.data.body, file);
                } else {
                    file.status = 'failed';
                    file.message = '上传失败';
                }
            }).catch(() => {
                file.status = 'failed';
                file.message = '上传失败';
            });
        },
        uploadBeforeDelete(file) {
            return true;
            // return new Promise((resolve, reject) => {
            //     deleteUploadFile({objectKey: getUrlRelativePath(file.url)}).then(response => {
            //         response.data.code === Config.successCode ? reject() : resolve(false)
            //     });
            // });
        },
        upload(params, file) {
            let formData = new FormData();
            formData.append('OSSAccessKeyId', params.accessKey);
            formData.append('policy', params.policy);
            formData.append('Signature', params.signature);
            formData.append('key', params.objectKey);
            formData.append('success_action_status', '200');
            formData.append('file', file.file);
            let config = {headers: {'Content-Type': 'multipart/form-data'}};
            axios.post(params.uploadUrl, formData, config).then(res => {
                if (res.status === 200) {
                    file.status = 'done';
                    file.message = '上传成功';
                    file.objectKey = params.objectKey;
                } else {
                    file.status = 'failed';
                    file.message = '上传失败';
                }
            }).catch(() => {
                file.status = 'failed';
                file.message = '上传失败';
            });
        }
    }
}